const ClipboardEvents = ['onCopy', 'onCut', 'onPaste'];

//中文输入法
const CompositionEvents = [
  'onCompositionEnd',
  'onCompositionStart',
  'onCompositionUpdate',
];

const KeyboardEvents = ['onKeyDown', 'onKeyPress', 'onKeyUp'];

const FocusEvents = ['onFocus', 'onBlur'];

const FormEvents = ['onChange', 'onInput', 'onInvalid', 'onReset', 'onSubmit'];

const GenericEvents = ['onError', 'onLoad'];

const ImageEvents = ['onLoad', 'onError'];

const MouseEvents = [
  'onClick',
  'onContextMenu',
  'onDoubleClick',
  'onDrag',
  'onDragEnd',
  'onDragEnter',
  'onDragExit',
  'onDragLeave',
  'onDragOver',
  'onDragStart',
  'onDrop',
  'onMouseDown',
  'onMouseEnter',
  'onMouseLeave',
  'onMouseMove',
  'onMouseOut',
  'onMouseOver',
  'onMouseUp',

  'onLongPress',
  'onLongTap',
];

//笔 鼠标 等
const PointerEvents = [
  'onPointerDown',
  'onPointerMove',
  'onPointerUp',
  'onPointerCancel',
  'onGotPointerCapture',
  'onLostPointerCapture',
  'onPointerEnter',
  'onPointerLeave',
  'onPointerOver',
  'onPointerOut',
];

const SelectionEvents = ['onSelect'];

const TouchEvents = [
  'onTouchCancel',
  'onTouchEnd',
  'onTouchMove',
  'onTouchStart',
  'onTouchOption',
];

const UIEvents = ['onScroll'];

const WheelEvents = ['onWheel'];

const MediaEvents = [
  'onAbort',
  'onCanPlay',
  'onCanPlayThrough',
  'onDurationChange',
  'onEmptied',
  'onEncrypted',
  'onEnded',
  'onError',
  'onLoadedData',
  'onLoadedMetadata',
  'onLoadStart',
  'onPause',
  'onPlay',
  'onPlaying',
  'onProgress',
  'onRateChange',
  'onSeeked',
  'onSeeking',
  'onStalled',
  'onSuspend',
  'onTimeUpdate',
  'onVolumeChange',
  'onWaiting',
];

const AnimationEvents = [
  'onAnimationStart',
  'onAnimationEnd',
  'onAnimationIteration',
];

const TransitionEvents = ['onTransitionEnd'];

const OtherEvents = ['onToggle'];

const RNEvents = ['onPress'];

// 仿小程序事件
const minipEvents = [
  'tap',
  'aim',
  'longpress',
  'longtap',
  'catchtap',
  'touchstart',
  'touchmove',
  'touchcancel',
  'touchend',
  'catchlongpress',
  'catchlongtap',
  'catchtouchstart',
  'catchtouchmove',
  'catchtouchcancel',
  'catchtouchend',
];

export const allEvent = [].concat(
  ClipboardEvents,
  CompositionEvents,
  KeyboardEvents,
  FocusEvents,
  FormEvents,
  ImageEvents,
  MouseEvents,
  PointerEvents,
  SelectionEvents,
  TouchEvents,
  UIEvents,
  WheelEvents,
  MediaEvents,
  AnimationEvents,
  TransitionEvents,
  RNEvents,
  OtherEvents,
  minipEvents
);
